<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end sp-padding__top">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="sp-padding__x2 sp-padding__bottom">
    <h3 class="sp-color__accent sp-margin__bottom">
      {{ (cluster ? 'CLUSTER.EDIT_VERSION_TITLE' : 'CLUSTER.ADD_VERSION_TITLE') | translate }}
    </h3>
    <form [formGroup]="form" class="sp-margin__top-x2">
      <div class="sp-row__align sp-wrap">
        <mat-form-field class="sp-width__half sp-width__full-md sp-form-field sp-margin__right sp-margin__bottom" appearance="fill" color="accent">
          <mat-label>{{ 'CLUSTER.VALID_FROM_COLUMN_LABEL' | translate }}</mat-label>
          <input
            id="cluster-valid-from"
            matInput
            type="text"
            formControlName="valid_from"
            [matDatepicker]="cluster_valid_from_picker"
            required />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="cluster_valid_from_picker"></mat-datepicker-toggle>
          <mat-datepicker #cluster_valid_from_picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="sp-width__half sp-width__full-md sp-form-field sp-margin__bottom" appearance="fill" color="accent">
          <mat-label>{{ 'CLUSTER.VALID_TO_COLUMN_LABEL' | translate }}</mat-label>
          <input
            id="cluster-valid-to"
            matInput
            type="text"
            formControlName="valid_to"
            [matDatepicker]="cluster_valid_to_picker"
            required />
          <mat-datepicker-toggle
            matIconSuffix
            [for]="cluster_valid_to_picker"></mat-datepicker-toggle>
          <mat-datepicker #cluster_valid_to_picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div formArrayName="configurations" class="sp-margin__top-x2">
        <div
          *ngFor="let configuration of configurations.controls; let index = index"
          [formGroupName]="index"
          class="sp-row__space sp-row__align sp-wrap sp-padding__vert sp-border__bottom">
          <span class="sp-color__primary sp-text__bold sp-margin__right">
            {{ configuration.get('steps_number')?.value }} {{ 'CLUSTER.STEPS_NUMBER_COLUMN_LABEL' | translate }}
          </span>
          <mat-form-field class="sp-form-field sp-margin__top" appearance="fill" color="accent">
            <mat-label>{{ 'CLUSTER.MAX_TAN_COLUMN_LABEL' | translate }}</mat-label>
            <input
              id="cluster-max-tan-{{ index }}"
              matInput
              type="number"
              step="0.01"
              formControlName="max_tan"
              required />
            <span matSuffix>%</span>
          </mat-form-field>
        </div>
      </div>
      <app-shared-button
        class="sp-width__full sp-margin__top-x2"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="is_submit_running"
        [is_spinner_visible]="is_submit_running"
        (click)="onSubmitClick()"
        (keydown.enter)="onSubmitClick()"></app-shared-button>
    </form>
  </div>
</div>